import React from "react"
import { useRouter } from "next/router"
import { STATES, STATE_COURT_MAP, INFORMATION_BASE_PATH } from "~/components/traffic-tickets/information/constants"
import TrafficInformation from "~/components/traffic/information/Local"
import Layout from "~/components/Pages/Basic"

const TrafficCourtInformation = () => {
  const router = useRouter();
  if (!router.query || !router.query.state || !STATES[router.query.state]) {
    if (process.browser) router.replace(INFORMATION_BASE_PATH)
    return <Layout>Not Found</Layout>
  }
  if (!router.query.court || !STATE_COURT_MAP[router.query.state] || !STATE_COURT_MAP[router.query.state][router.query.court]) {
    if (process.browser) router.replace(`${INFORMATION_BASE_PATH}/${router.query.state}`);
    return <Layout>Not Found</Layout>
  }
  const court = STATE_COURT_MAP[router.query.state][router.query.court];
  const state = STATES[router.query.state]
  return (
    <TrafficInformation
      title={court.title}
      description={court.description}
      state={state}
      content={court.content}
    />
  )
}

export default TrafficCourtInformation
